


import usePayingModal from "../components/usePayingModal";
import useEquip from '../../../hooks/useEquip'
import { useIntl } from "react-intl";
export default function useShop() {
  const payingModal = usePayingModal()
  const intl = useIntl()
  const {
    toRedeemQuility,
    toRedeemEqiup,
    toBuyQuility,
    toBuyEqiup,
  } = useEquip({intl});
  
  // 兑换
  // 属性卡
  const redeemQuility = async (card) => {
    let loading
    await toRedeemQuility(card,() => {
      loading = payingModal.show({
        info: card,
        cost: card.price0 + " RBCT",
      });
      return loading
    },() => {
      loading && loading.close()
    })
  };

  // 装备
  const redeemEqiup = async (eqiup) => {

    let loading
    await toRedeemEqiup(eqiup,() => {
      
      loading = payingModal.show({
        info: eqiup,
        cost: eqiup.price0 + " RBET",
      });
      return loading
    },() => {
      loading && loading.close()
    })
  
  };

  // 购买
  // 属性卡
  const buyQuility = async (card) => {
    let loading
    await toBuyQuility(card,() => {
      
      loading = payingModal.show({
        info: card,
        cost: card.price1 + " RT",
      });
      return loading
    },() => {
      loading && loading.close()
    })
  };
  // 装备
  const buyEqiup = async (eqiup) => {
    let loading
    await toBuyEqiup(eqiup,() => {
      
      loading = payingModal.show({
        info: eqiup,
        cost: eqiup.price1 + " RT",
      });
      return loading
    },() => {
      loading &&loading.close()
    })
  };

  return {
    redeemQuility,
    redeemEqiup,
    buyQuility,
    buyEqiup,
  };
}
